import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import styles from './Alert.module.css';
import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from './icons';

export type AlertTone = 'info' | 'success' | 'warning' | 'error';

export interface AlertProps {
  readonly tone?: AlertTone;
  readonly title?: string | undefined;
  readonly children: ReactNode;
}

const ICONS = {
  info: InfoIcon,
  success: SuccessIcon,
  warning: WarningIcon,
  error: ErrorIcon,
} as const;

export function Alert({ tone = 'info', title, children }: AlertProps) {
  const { t } = useTranslation();
  const Icon = ICONS[tone];

  // `alert` interrompe o leitor de tela; `status` espera a pausa. Interromper
  // por uma confirmacao de sucesso e ruido, e nao interromper por um erro e
  // deixar a pessoa seguir com o formulario quebrado.
  const role = tone === 'error' || tone === 'warning' ? 'alert' : 'status';

  return (
    <div className={[styles.alert, styles[tone]].join(' ')} role={role}>
      <Icon className={styles.icon} />
      <span className="visually-hidden">{`${t(`alert.${tone}`)}: `}</span>
      <div className={styles.body}>
        {title ? <p className={styles.title}>{title}</p> : null}
        {children}
      </div>
    </div>
  );
}
